const initialState = {
    SLIDER_IS_OPEN: false
};

const state = JSON.parse(JSON.stringify(initialState));

const actions = {};

const mutations = {
    resetState(state) {
        state.SLIDER_IS_OPEN = initialState.SLIDER_IS_OPEN;
    },
    toggleSlider(state) {
        state.SLIDER_IS_OPEN = !state.SLIDER_IS_OPEN;
    }
};
const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
